import cook from 'vue-cookies'

export default {
  namespaced: true,
  state: cook.get('willingbot_store') ? cook.get('willingbot_store').user : {
    userId: 0,               //用户ID标识
    token: '',                //登录token
    userInfo: '',             //用户信息
    userPermissions: [],       //用户权限
  },
  mutations: {
    login (state, loginData) {                      //登录
      state.userId = loginData.id
      state.token = loginData.accessToken
    },
    getInfo (state, data) {                    //获取用户信息
      state.userInfo = data
    },
    getPermissions (state, data) {             //获取权限
      state.userPermissions = data
    },
    logout (state) {                          //退出登录
      state.token = ''
    },
    getAccountPolicyInfo(state, data){         // 密码校验规则
      state.getAccountPolicy = cook.get('getAccountPolicy')
    },
  }
}
